import { render, staticRenderFns } from "./BodyMeasurementsSection.vue?vue&type=template&id=0e2fae92&"
import script from "./BodyMeasurementsSection.vue?vue&type=script&lang=js&"
export * from "./BodyMeasurementsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports